import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as _colors from 'material-ui/styles/colors';

let strUrl = location.search;
let getPara, ParaVal;
let aryPara = [];

if (strUrl.indexOf("?") !== -1) {
	let getSearch = strUrl.split("?");
	getPara = getSearch[1].split("&");
	for (let i = 0; i < getPara.length; i++) {
		ParaVal = getPara[i].split("=");
		aryPara.push(ParaVal[0]);
		aryPara[ParaVal[0]] = ParaVal[1];
	}
}

const muiTheme = getMuiTheme({
	palette: {
		primary1Color: aryPara.app === 'true' ? '#2F5A7C' : _colors.blue300,
		accent1Color: _colors.orange300
	},
	appBar: {
		height: 48, // Instead of 64
	}
});

export default muiTheme;


// WEBPACK FOOTER //
// ./src/components/ppappTheme.js